<template>
    <div class="m-3">
        Prodano
    </div>
</template>

<script>
export default {
    name: "Sold",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
